// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2cv1X","footer":"ChangeClinic_footer__iISCm"};